<template>
  <c-loading-area :loading="loading">
    <v-card-title>
      {{ $t('page.receiptFilingFees.table.title') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('page.receiptFilingFees.table.description') }}
    </v-card-subtitle>
    <v-card-text class="pa-0 mt-n4">
      <v-data-table
        :items="filings"
        :headers="headers"
        class="mt-2"
        item-key="resourceID"
        hide-default-footer
        disable-pagination
        :mobile-breakpoint="800">
        <template #item.filing="{ item }">
          <div>
            <div style="white-space: nowrap">
              <router-link :to="{ name: 'manage-filing', params: { filingID: item.resourceID } }">
                {{ item.referenceNumber }}
              </router-link>
            </div>
            <div>
              {{ item.referenceName }}
            </div>
          </div>
        </template>
        <template #item.caseNumber="{ item }">
          <div>
            <div v-if="!item.caseNumber">
              {{ $t('page.filingResults.newCaseFiling') }}
            </div>
            <div v-if="showCaseLink(item)" style="white-space: nowrap">
              <router-link :to="{ name: 'caseView', params: { courtID: item.courtResourceID, caseUUID: item.caseIdentifier} }">
                {{ item.caseNumber }}
              </router-link>
            </div>
            <div v-else style="white-space: nowrap">
              {{ item.caseNumber }}
            </div>
            <div v-if="!isNil(getCaseTitle(item))">
              {{ getCaseTitle(item) }}
            </div>
          </div>
        </template>
        <template #item.feeTotal="{ value }">
          {{ value | formatCurrency }}
        </template>
      </v-data-table>
    </v-card-text>
  </c-loading-area>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import { useApplicationStore } from '@/stores/applicationStore';

const applicationStore = useApplicationStore();

export default {
  props: {
    receiptID: {
      type: String
    }
  },
  data () {
    return {
      loading: true,
      filings: []
    };
  },
  created () {
    let query = {
      receiptID: this.receiptID,
      size: this.CONST.PAGING_MAX_SIZE
    };

    let url = this.$cove.getAPI({ name: 'api.filings', query });
    axios.get(url)
      .then((response) => {
        this.filings = _.get(response, 'data._embedded.results', []);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    headers () {
      let headers = [];
      if (!this.isSingleCourtMode)
      {
        headers.push({ text: this.$t('courtCase.court'), value: 'courtDisplayName', sortable: false });
      }

      headers.push({ text: this.$t('page.receiptFilingFees.table.filing'), value: 'filing', sortable: false });
      headers.push({ text: this.$t('courtCase.case'), value: 'caseNumber', sortable: false });
      headers.push({ text: this.$t('filing.leadDocketEntry'), value: 'docketEntryExternalName', sortable: false });
      headers.push({ text: this.$t('page.receiptFilingFees.table.feeAmount'), value: 'feeTotal', sortable: false });

      return headers;
    },
    isSingleCourtMode () {
      return applicationStore.isSingleCourtMode;
    }
  },
  methods: {
    getCaseTitle (item) {
      let caseTitle = null;
      if (!_.isNil(item.caseNumber))
      {
        caseTitle = (!_.isNil(item.filerCaseAccessible) && item.filerCaseAccessible) ?
          item.caseTitle : this.$t('courtCase.secure');
      }

      return caseTitle;
    },
    showCaseLink (item) {
      return item.filerCaseAccessible && !_.isNil(item.caseIdentifier);
    }
  }
};
</script>